import * as ng from 'angular';
import { StRatio } from './st-ratio.directive';

export const StRatioModule: string =
    ng.module('st-ratio', [
    ])
        .directive('stRatio', StRatio)
        .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/third/smart-table/st-ratio/st-ratio.module.ts